module.exports = __webpack_public_path__ + "static/media/work-at-home.44318fc8.png";